import React, { useState } from "react";
import { toast } from "react-toastify";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Router, useNavigate } from "react-router-dom";
import PrintIcon from "@mui/icons-material/Print";

// import JS files
import MuiButton from "../../../shares/MuiButton";
import PanelTable from "../../../shares/PanelTable";
import { useUserData } from "../../../../context/UserDataContext";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";

const headersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand", name: "برند" },
  { colName: "size_one_num", name: "سایز ۱" },
  { colName: "size_two_num", name: "سایز ۲" },
  { colName: "size_three_num", name: "سایز ۳" },
  { colName: "size_four_num", name: "سایز ۴" },
  { colName: "size_five_num", name: "سایز ۵" },
  { colName: "size_six_num", name: "سایز ۶" },
];

const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand", name: "برند" },
];

const dataKey = [
  "code",
  "show_name",
  "gender",
  "color",
  "brand",
  "object.bangle_request_nums.size_one_num",
  "object.bangle_request_nums.size_two_num",
  "object.bangle_request_nums.size_three_num",
  "object.bangle_request_nums.size_four_num",
  "object.bangle_request_nums.size_five_num",
  "object.bangle_request_nums.size_six_num",
];

const AdminReportsBangleInfo = () => {
  const [codeFilter, setCodeFilter] = useState(null);
  const navigate = useNavigate();

  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
  ];

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    getRequestListApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    getRequestListApi.reFetch();
  };

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const [requestList, setRequestList] = useState([]);

  const getRequestListApi = useFetch({
    method: "get",
    params: {
      code: fixNumbers(codeFilter),
    },
    url: `User_Service/${useUserData.username}/admin_get_report_bangle_per_provider_request`,
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const buttonsList = [];

  const actionsList = [];

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRequestList([]);
    getRequestListApi.reFetch();
  };

  const handelPrintReport = () => {
    navigate("/print-report-bangle-info");
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="r-general-info">
        <>
          <div className="panel-main-header">
            <span>اطلاعات کلی النگوها</span>
          </div>
          <PanelFilter
            header="فیلتر :"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست النگوهای ثبت شده:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={requestList}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AddShoppingCartIcon />}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default AdminReportsBangleInfo;
